const MIN_DISTANCE_IN_KM_EXAM = '25';

export {MIN_DISTANCE_IN_KM_EXAM};
